export function roundFloatNumberToOnePlace (averageRating) {
  return Math.round(averageRating * 10) / 10
}

export function roundToHalf (number) {
  return Math.round(number * 2) / 2
}

export function calculateAverage (array) {
  return array.reduce((prev, curr) => curr + prev, 0) / array.length
}



// WEBPACK FOOTER //
// ./src/shared/math.js